import React from 'react';
import {
  type BundledLanguage,
  type BundledTheme,
  getSingletonHighlighter,
} from 'shiki';

// Singleton highlighter for JSON
let jsonHighlighterInstance: Awaited<
  ReturnType<typeof getSingletonHighlighter>
> | null = null;

export const getJsonHighlighter = async () => {
  if (!jsonHighlighterInstance) {
    jsonHighlighterInstance = await getSingletonHighlighter({
      themes: ['github-light', 'github-dark'],
      langs: ['json'],
    });
  }
  return jsonHighlighterInstance;
};

export const highlightJson = async (
  code: string,
  theme: BundledTheme
): Promise<React.ReactElement[]> => {
  const highlighter = await getJsonHighlighter();

  const tokens = highlighter.codeToTokens(code, {
    lang: 'json' as BundledLanguage,
    theme,
  });

  return (tokens?.tokens ?? []).map((line, lineIndex: number) => (
    <div key={lineIndex} style={{ display: 'block' }}>
      {line.map((token, tokenIndex: number) => (
        <span
          key={tokenIndex}
          style={{
            color: token.color,
            whiteSpace: 'pre-wrap',
          }}
        >
          {token.content}
        </span>
      ))}
    </div>
  ));
};
